import { userConstants } from "../../constant";

export function products(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ALL_PRODUCTS_SUCCESS:
      return {
        products: action.products,
      };

    case userConstants.GET_A_PRODUCT_FAILURE:
      return {
        error: action.error,
      };

    case userConstants.GET_ALL_PRODUCTS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
